import { AllowedLimits, CONTRACT, useAllowance } from '@apeiron/contract'
import {
  CurrencyTokenType,
  CurrencyTokenTypeERC20,
  useCurrencyContext
} from '@apeiron/currency'
import { useWeb3 } from '@apeiron/temp'
import { useCallback } from 'react'
import { Address } from 'viem'

const useAllowCurrency = () => {
  const { toWei } = useWeb3()

  const { getCurrency } = useCurrencyContext()

  const { request: requestWETH } = useAllowance({
    contractTypes: {
      allowance: CONTRACT.CURRENCY.WETH.GET_USER_ALLOWANCE,
      request: CONTRACT.CURRENCY.WETH.REQUEST_ALLOWANCE
    }
  })

  const { request: requestUSDC } = useAllowance({
    contractTypes: {
      allowance: CONTRACT.CURRENCY.USDC.GET_USER_ALLOWANCE,
      request: CONTRACT.CURRENCY.USDC.REQUEST_ALLOWANCE
    }
  })

  const { request: requestANIMA } = useAllowance({
    contractTypes: {
      allowance: CONTRACT.CURRENCY.ANIMA.GET_USER_ALLOWANCE,
      request: CONTRACT.CURRENCY.ANIMA.REQUEST_ALLOWANCE
    }
  })

  const { request: requestAPRS } = useAllowance({
    contractTypes: {
      allowance: CONTRACT.CURRENCY.APRS.GET_USER_ALLOWANCE,
      request: CONTRACT.CURRENCY.APRS.REQUEST_ALLOWANCE
    }
  })

  const requestCurrency = useCallback(
    async (
      from: Address,
      to: Address,
      currencyType: CurrencyTokenTypeERC20,
      price: bigint,
      messages: Messages = {}
    ): Promise<boolean> => {
      const currency = getCurrency(currencyType)

      switch (currencyType) {
        case CurrencyTokenType.Anima:
          return requestANIMA(
            from,
            to,
            price,
            BigInt(
              toWei(
                AllowedLimits[CurrencyTokenType.Anima],
                currency?.decimals || 18
              )
            ),
            messages
          )
        case CurrencyTokenType.Weth:
          return requestWETH(
            from,
            to,
            price,
            BigInt(
              toWei(
                AllowedLimits[CurrencyTokenType.Weth],
                currency?.decimals || 18
              )
            ),
            messages
          )
        case CurrencyTokenType.Usdc:
          return requestUSDC(
            from,
            to,
            price,
            BigInt(
              toWei(
                AllowedLimits[CurrencyTokenType.Usdc],
                currency?.decimals || 6
              )
            ),
            messages
          )
        case CurrencyTokenType.Aprs:
          return requestAPRS(
            from,
            to,
            price,
            BigInt(
              toWei(
                AllowedLimits[CurrencyTokenType.Aprs],
                currency?.decimals || 18
              )
            ),
            messages
          )
        default:
          return false
      }
    },
    [getCurrency, requestANIMA, requestAPRS, requestUSDC, requestWETH, toWei]
  )

  return {
    requestCurrency
  }
}

type Messages = {
  checkMessage?: string
  waitMessage?: string
}

export default useAllowCurrency
